var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediShot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M1.148.458C.619.376.278.887.224 1.3c.444.219.665.309.788.892l1.001-1.096c-.429-.155-.707-.183-.865-.64Zm1.043.802-.992 1.07c.164.187.354.414.603.4l.842-.931c-.074-.323-.256-.444-.453-.54Zm1.831.44a2.711 2.711 0 0 0-.99.062c-.586.344-.902.84-1.228 1.329-.473 1.77 1.351 2.677 2.525 2.09l2.039 1.833c.456-.103.745-.583.826-.905L5.159 4.23c.468-1.076.115-2.35-1.137-2.53Zm-.33.727a.924.924 0 0 1 .264.083l-.416.552-.522-.42a.845.845 0 0 1 .673-.215Zm.756.518c.261.32.18.684.054.945l-.52-.43Zm-1.82.139.451.457-.48.419c-.168-.194-.278-.483.03-.876Zm.92.926.485.415c-.27.218-.551.392-.867.038Zm3.77 2.367-.677.793c.365.28.728.573 1.101.802.24-.159.502-.286.516-.773Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediShot);
export default __webpack_public_path__ + "static/media/medi-shot.27cd8fe5a0a6af404f1f813c16b08afb.svg";
export { ForwardRef as ReactComponent };